<template>
  <d-container
    fluid
    class="main-content-container px-4">
    <!-- Page Header -->
    <d-row
      no-gutters
      class="page-header py-4">
      <d-col
        col
        sm="6"
        class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Produkty</span>
        <h3 class="page-title">
          <template v-if="isEdit">Edycja produktu</template>
          <template v-else>Dodawanie produktu</template>
        </h3>
      </d-col>
      <d-col
        col
        sm="6"
        class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          theme="secondary"
          @click.prevent="$router.push('/produkty')"
          class="mr-1">
          <i class="material-icons">arrow_back</i>
          Wróć do listy
        </d-button>
        <d-button
          theme="success"
          :class="{isLoading : submitting}"
          @click.prevent="validateForm">
          Zapisz zmiany
        </d-button>
      </d-col>
    </d-row>

    <!-- Form -->
    <d-form>
      <d-card class="mb-5">
        <d-tabs card>
          <!-- Dane ogólne -->
          <d-tab
            title="Dane ogólne"
            active>
            <h4 class="mb-3 pb-3 border-bottom">
              Dane ogólne
            </h4>
            <validation-observer
              ref="products-form"
              tag="form">
              <div class="form-group">
                <label for="name">
                  Nazwa produktu:
                </label>
                <validation-provider
                  rules="required"
                  name="name"
                  v-slot="{ errors }">
                  <d-input
                    :state="errors.length ? 'invalid' : null"
                    v-model="data.name" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
              <d-row>
                <d-col
                  cols="12"
                  md="6">
                  <div class="form-group">
                    <label
                      class="title-box"
                      :for="data.settlement_method">
                      Kategoria produktu:
                    </label>
                    <div class="form-control is-select">
                      <v-select
                        :options="categories"
                        v-model="data.category_id"
                        :reduce="category => category.id"
                        :placeholder="'Wybierz kategorię'"
                        label="name">
                      </v-select>
                    </div>
                  </div>
                </d-col>
                <d-col
                  cols="12"
                  md="6">
                  <div class="form-group">
                    <label class="title-box">
                      Grupa produktowa:
                    </label>
                    <div class="form-control is-select">
                      <v-select
                        :options="productGroups"
                        v-model="data.product_group_id"
                        :reduce="group => group.id"
                        :placeholder="'Wybierz grupę'"
                        label="name">
                      </v-select>
                    </div>
                  </div>
                </d-col>
              </d-row>
              <d-row>
                <d-col>
                  <div class="form-group">
                    <validation-provider
                      :rules="'required'"
                      :name="'settlement_method'"
                      v-slot="{ errors }">
                      <label
                        class="title-box"
                        :for="data.settlement_method">
                        Wymaga ważenia:
                      </label>
                      <div :class="{ 'form-control': true, 'is-select': true, 'is-invalid': errors.length }">
                        <v-select
                          :options="weighingType"
                          v-model="data.weighing_required"
                          :reduce="weighing => weighing.id"
                          :placeholder="'Wymaga ważenia'"
                          label="id"
                          :state="errors.length ? 'invalid' : null">
                          <template
                            slot="option"
                            slot-scope="option">
                            <div class="d-center">
                              {{ option.name }}
                            </div>
                          </template>
                          <template
                            slot="selected-option"
                            slot-scope="option">
                            <div class="selected d-center">
                              {{ option.name }}
                            </div>
                          </template>
                        </v-select>
                      </div>
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>
                <d-col
                  md="4"
                  v-if="data.weighing_required === 1">
                  <div class="form-group">
                    <validation-provider
                      :rules="'required'"
                      :name="'defualut_unit'"
                      v-slot="{ errors }">
                      <label
                        class="title-box"
                        :for="data.settlement_method">
                        Podstawowa jednostka:
                      </label>
                      <div :class="{ 'form-control': true, 'is-select': true, 'is-invalid': errors.length }">
                        <v-select
                          class="user-select-style"
                          :key="data.default_unit"
                          :options="unitType"
                          :placeholder="'Wybierz podstawową jednostkę'"
                          v-model="data.default_unit"
                          :reduce="unit => unit.value"
                          label="name"
                          :state="errors.length ? 'invalid' : null">
                        </v-select>
                      </div>
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>
              </d-row>

              <div
                class="form-group"
                v-if="data.weighing_required === 1">
                <validation-provider
                  name="price"
                  rules="required|min_value:0"
                  v-slot="{ errors }">
                  <label for="price">
                    Średnia waga 1 sztuki <b>(kg)</b>:
                  </label>
                  <input
                    :class="{
                      'form-control': true,
                      'is-invalid': errors.length
                    }"
                    :step="0.01"
                    :min="0.0"
                    :state="errors.length ? 'invalid' : null"
                    type="number"
                    v-model="data.average_weight" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
              <d-row>
                <d-col
                  cols="6"
                  md="6"
                  lg="8">
                  <div class="form-group">
                    <validation-provider
                      name="price"
                      rules="required|min_value:0"
                      v-slot="{ errors }">
                      <label for="price">
                        Cena:
                      </label>
                      <input
                        :class="{
                          'form-control': true,
                          'is-invalid': errors.length
                        }"
                        :step="0.01"
                        :min="0.0"
                        :state="errors.length ? 'invalid' : null"
                        type="number"
                        v-model="data.price" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>
                <d-col
                  cols="6"
                  md="6"
                  lg="4">
                  <div class="form-group">
                    <validation-provider
                      name="vat_rate"
                      rules="required"
                      v-slot="{ errors }">
                      <label for="vat_rate">Podatek VAT:</label>
                      <div :class="{ 'form-control': true, 'is-select': true, 'is-invalid': errors.length }">
                        <v-select
                          :options="vatType"
                          :reduce="type => type.value"
                          v-model="data.vat_rate"
                          placeholder="Wybierz podatek VAT"
                          label="name"
                          :state="errors.length ? 'invalid' : null">
                        </v-select>
                      </div>
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>
              </d-row>
              <d-row>
                <d-col>
                  <div class="form-group">
                    <d-checkbox
                      class="mt-3 ml-3"
                      inline
                      v-model="data.include_on_invoices_new"
                      toggle>
                      <span v-if="data.include_on_invoices_new === true">
                        <span
                          style="font-weight: 600"
                        class="text-success">TAK</span> - Produkt <b>uwzględniany</b> na fakturach.
                      </span>
                      <span v-if="data.include_on_invoices_new === false">
                        <span
                          style="font-weight: 600"
                        class="text-secondary">NIE</span> - Produkt <b>nie uwzględniany</b> na fakturach.
                      </span>
                    </d-checkbox>
                  </div>
                </d-col>
                <d-col>
                  <div class="form-group">
                    <d-checkbox
                      class="mt-3 ml-3"
                      inline
                      v-model="data.show_in_form_new"
                      toggle>
                      <span v-if="data.show_in_form_new">
                        <span
                          style="font-weight: 600"
                        class="text-success">TAK</span> - <b>Pokazuj</b> na formularzu www klienta.
                      </span>
                      <span v-if="!data.show_in_form_new">
                        <span
                          style="font-weight: 600"
                        class="text-secondary">NIE</span> - <b>Nie pokazuj</b> na formularzu www klienta.
                      </span>
                    </d-checkbox>
                  </div>
                </d-col>
              </d-row>
              <d-row>
                <d-col md="6">
                  <div class="form-group">
                    <label for="ordering">
                      Kolejność:
                    </label>
                    <validation-provider
                      rules="required|min_value:1"
                      name="ordering"
                      v-slot="{ errors }">
                      <d-input
                        id="ordering"
                        type="number"
                        :state="errors.length ? 'invalid' : null"
                        v-model="data.ordering" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>

                <d-col md="12">
                  <div class="form-group">
                    <label>
                      Zdjęcie produktu:
                    </label>

                    <div class="">
                      <div
                        v-if="data.image_url"
                        class="mb-1 mt-1">
                        <d-img
                          fluid
                          rounded
                          width="100%"
                          height="auto"
                          center
                          style="min-width: 100%;"
                          :src="data.image_url" />
                      </div>

                      <div
                        v-if="data.image_url"
                        class="text-center pt-2">
                        <d-link
                          @click.prevent="removeProductImage()"
                          title="Usuń zdjęcie"
                          class="text-danger">
                          Usuń zdjęcie
                        </d-link>
                      </div>

                      <file-input
                        v-if="!data.image_url"
                        :onChange="setProductImage"
                        id="inputFileProductImage" />
                    </div>
                  </div>
                </d-col>
              </d-row>
            </validation-observer>
            <div
              v-if="!allDataLoaded"
              class="pb-3 pt-3 text-center">
              Trwa ładowanie danych&hellip;
            </div>
            <d-alert
              v-if="load_error"
              show
              theme="warning">
              Wczytywanie danych nie powiodło się. <a
                href="javascript:window.location.reload();"
              class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
            </d-alert>
          </d-tab>
        </d-tabs>
      </d-card>
    </d-form>
  </d-container>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'suppliers-form',
  computed: {
    unitType () {
      return [
        {
          label: 'kg',
          name: 'Kilogramy',
          value: 'KILOGRAM'
        },
        {
          label: 'szt',
          name: 'Sztuki',
          value: 'PIECE'
        },
      ];
    },
    weighingType () {
      return [
        {
          name: 'TAK',
          id: 1
        },
        {
          name: 'NIE',
          id: 0
        },
      ];
    },
    allDataLoaded () {
      return this.loaded && this.loaded_suppliers;
    },
    isEdit () {
      return !!this.$route.params.id;
    },
    vatType () {
      return [
        {
          name: '23%',
          value: 23
        },
        {
          name: '8%',
          value: 8
        },
        {
          name: '5%',
          value: 5
        },
        {
          name: '0%',
          value: 0
        },
      ];
    },
  },
  data () {
    return {
      data: {
        id: 0,
        name: '',
        unit: '',
        average_weight: 0,
        price: '',
        vat_rate: '',
        weighing_required: '',
        include_on_invoices: '',
        default_unit: 'KG',
        category_id: 0,
        product_group_id: 0,
        include_on_invoices_new: false,
        show_in_form: '',
        show_in_form_new: true,
        ordering: null,
        image: null,
        image_url: null
      },
      submitting: false,
      loaded: false,
      important_price: false,
      loaded_suppliers: false,
      weighing_required_required: false,
      load_error: false,
      categories: [],
      productGroups: []
    };
  },
  mounted () {
    if (this.isEdit) {
      this.loadItemData();
    } else {
      this.loaded = true;
    }

    this.loadAdditionalData();
    this.getCategories();
    this.getProductGroups();
  },
  watch: {
    'data.include_on_invoices': function (value) {
      this.data.include_on_invoices_new = value === 1;
    },
    'data.show_in_form': function (value) {
      this.data.show_in_form_new = value === 1;
    },
    'data.weighing_required': function (value) {
      if (!this.loaded) {
        return;
      }
      if (value === '0' || value === 0) {
        this.data.unit = 'PIECE';
        this.data.default_unit = 'PIECE';
        if (this.data.average_weight === '') {
          this.data.average_weight = 1.00;
        }
      }
      if (value === '1' || value === 1) {
        this.data.default_unit = 'KILOGRAM';
        if (this.data.average_weight === '') {
          this.data.average_weight = 0.00;
        }
      }
    },
  },
  methods: {
    loadItemData () {
      FormUtils.loadItemData(this, {
        endpointBase: '/products/item/',
        instanceFields: ['name', 'unit', 'price', 'vat_rate', 'weighing_required', 'include_on_invoices', 'average_weight', 'category_id', 'product_group_id', 'show_in_form', 'default_unit', 'ordering', 'image', 'image_url'],
        loadedKey: 'loaded'
      });
    },
    loadAdditionalData () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/products/items',
        params: {
          pagination: false
        },
        outputKey: 'products',
        loadedKey: 'loaded_suppliers',
        errorKey: 'load_error',
      });
    },
    getCategories () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/categories/items',
        outputKey: 'categories',
        params: {
          pagination: false
        },
      });
    },
    getProductGroups () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/product-groups/items',
        outputKey: 'productGroups',
        params: {
          pagination: false
        },
      });
    },
    validateForm () {
      this.important_price = true;
      this.weighing_required_required = true;
      FormUtils.validate(this.$refs['products-form']);
      if (this.data.price !== '' && this.data.weighing_required !== '') {
        FormUtils.validate(this.$refs['products-form'], this.submitForm);
      }
    },
    submitForm () {
      this.weighing_required_required = false;
      let formDataToSend = this.prepareFormDataToSend();
      let endpointUrl = this.isEdit ? '/products/update/' + this.id : '/products/store';
      this.submitting = true;

      let imageFields = false;
      if (this.data.image instanceof File) {
        formDataToSend.image = this.data.image;
        imageFields = ['image'];
      } else if (this.data.image) {
        formDataToSend.image = this.data.image;
      } else {
        formDataToSend.image = '';
        formDataToSend.image_url = '';
      }

      FormUtils.submit(this, {
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: 'Zapisano produkt',
        successText: 'Wybrany produkt został zapisany',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Modyfikacja produktu nie powiodła się. Spróbuj ponownie.',
        successAction: () => {
          this.$router.push('/produkty');
          this.submitting = false;
        },
        failureAction: () => {
          this.submitting = false;
        }
      }, imageFields);
    },
    prepareFormDataToSend () {
      return {
        name: this.data.name,
        unit: this.data.unit,
        price: this.data.price,
        average_weight: this.data.average_weight,
        category_id: this.data.category_id,
        product_group_id: this.data.product_group_id || null,
        vat_rate: this.data.vat_rate,
        weighing_required: this.data.weighing_required,
        include_on_invoices: this.data.include_on_invoices_new ? 1 : 0,
        show_in_form: this.data.show_in_form_new ? 1 : 0,
        default_unit: this.data.default_unit,
        ordering: this.data.ordering
      };
    },
    removeProductImage () {
      this.data.image_url = '';
      this.data.image = '';
    },
    setProductImage (event) {
      this.data.image = event.target.files[0];
    }
  }
};
</script>
<style lang="scss">
  .invalid-unit {
    outline: none;
    color: var(--theme-color);
  }
  .invalid-feedback-unit {
    margin-top: -0.65rem;
    font-size: 80%;
    color: var(--theme-color);
  }
  .vat-select-style {
    .vs__actions {
      position: absolute;
      margin-left: 85%;
    }
  }
  .input-for-select {
    position: absolute;
    margin-top: -0.4rem;
    background: transparent;
    margin-left: -0.2rem;
    width: 100.6%;
  }
</style>
